import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { routeNames } from 'src/app/app-routing-names';
import { QuoteSteps } from '../models/enums/quote-steps';
import { MotorQuoteStateService } from '../services/motor-quote-state/motor-quote-state.service';
import { VehicleHandlerService } from '../services/vehicle-handler/vehicle-handler.service';

@Injectable({
    providedIn: 'root'
})
export class ManualCarGuard {
    constructor(public router: Router,
        private motorQuoteStateService: MotorQuoteStateService,
        private vehicleHandlerService: VehicleHandlerService
    ) { }

    canActivate(): boolean {
        return this.isAllowedNavigate();
    }

    isAllowedNavigate(): boolean {
        const currentStep = this.motorQuoteStateService.getCurrentStep();
        const displayManualCarLookup = this.vehicleHandlerService.displayManualCarLookup();

        if (!displayManualCarLookup && currentStep === QuoteSteps.manualCarLookup) {
            this.router.navigateByUrl(routeNames.SEARCH_REG);
        }

        return true;
    }

}